import { NavigationItem } from '@/types/navigation';
import { MenuItem } from './MenuItem';
import { SubMenu } from './SubMenu';
import { TopLinks } from './TopLinks';
import { SignInButton, SignOutButton } from './AccountIconButton';

const host = process.env.NEXT_PUBLIC_HOST_NAME ?? 'www.tempcover.com';

export const Navigation = ({
  data,
  open,
  activeSection,
  className,
  onClick,
  onEnter,
  onBack,
  loggedIn,
}: {
  data: NavigationItem[];
  open: boolean;
  activeSection: string;
  className?: string;
  onClick: (section: string) => void;
  onEnter: (section: string) => void;
  onBack: () => void;
  loggedIn?: boolean;
}) => {
  return (
    <nav className={`flex items-center justify-between gap-5 ${className}`} data-testid="navigation">
      <div
        className={`bg-background-200 fixed top-[var(--nav-mobile-height)] left-full flex h-[calc(100%-var(--nav-mobile-height))] w-lvw grow-0 flex-col gap-4 overflow-y-scroll px-4 pt-4 pb-16 text-center duration-500 lg:static lg:left-0 lg:h-auto lg:w-auto lg:translate-none lg:flex-row lg:gap-0 lg:overflow-hidden lg:bg-transparent lg:px-0 lg:pt-0 lg:pb-0 lg:text-left lg:transition-none ${open ? '-translate-x-full' : 'translate-x-none'}`}
        role="group"
      >
        <a className="tc-submit-button mb-4 block lg:hidden" href={`${host}/start-quote`} rel="nofollow">
          Get a quote
        </a>

        {data.map((item, index) => {
          const { name, sections, url } = item;
          const idx = `${name}-${index}`;

          if (item.enableDropdown && sections) {
            return (
              <SubMenu
                key={idx}
                name={name}
                content={sections}
                open={activeSection === name}
                onClick={() => onClick(name)}
                onEnter={() => onEnter(name)}
                onBack={onBack}
              />
            );
          }

          return <MenuItem key={idx} text={name} link={url!} />;
        })}
        <TopLinks className="block lg:hidden" />

        {/* Log in / Log out for mobile burger nav*/}
        {loggedIn
          ? open && <SignOutButton size={20} className="h-[40px] gap-1 md:hidden" />
          : open && <SignInButton size={20} className="h-[40px] gap-1 md:hidden" />}
      </div>

      {/* Hero CTA Buttons - Right */}
      <div className="account inline-flex items-center gap-5" role="none">
        {loggedIn ? (
          <div className="hidden md:block">
            <SignOutButton showTextSm={false} />
          </div>
        ) : (
          <SignInButton showTextSm={false} />
        )}
        <a className="tc-submit-button hidden lg:block" href={`${host}/start-quote`}>
          Get a quote
        </a>
      </div>
    </nav>
  );
};
